import React from "react";
import { useNavigate } from "react-router-dom";
import AuthHeader from "../../components/AuthHeader";
import Footer from "../../components/Footer";
import MobileViewLayout from "../../layouts/MobileViewLayout";
import { addS3Url } from "../../utils/modules";

const ManageSubscription = () => {
  const navigate = useNavigate();

  return (
    <>
      <MobileViewLayout>
        <div className={`d-flex flex-grow-1 flex-column`}>
          <div className="px-3" style={{}}>
            <AuthHeader />
          </div>
          <hr className="m-0 p-0 my-3" />
          <div
            className="text-center px-3 d-flex flex-column"
            style={{
              paddingBottom: "18px",
              flex: 1,
            }}
          >
            <div
              className="d-flex justify-content-center mt-3 mb-2"
              style={{ position: "relative" }}
            >
              <div className="">
                <img
                  src={addS3Url("/courses/arrow-left.svg")}
                  alt=""
                  className=""
                  style={{
                    width: "25px",
                    height: "25px",
                    position: "absolute",
                    top: "20%",
                    left: "0",
                  }}
                  onClick={() => navigate("/courses")}
                />
              </div>
              <div style={{}}>
                <p className="manage-sub-title fw-bold m-0 p-0">
                  Manage Subscription
                </p>
              </div>
            </div>
            <button
              className="subscription-btn w-100 fw-bold mt-4"
              onClick={() => {}}
            >
              Active
            </button>

            <div
              className="mt-5 flex-grow-1"
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <p
                className="fw-600 m-0 p-0"
                style={{
                  fontWeight: "600",
                  fontSize: "18px",
                }}
              >
                Do you want to cancel? <br /> Reach our friendly support team{" "}
                <a href="mailto:support@freelanz.app?subject=Cancel%20Subscription">
                  here
                </a>
              </p>
            </div>
          </div>
        </div>
      </MobileViewLayout>
      <div className=" flex-grow-1 d-flex flex-column align-items-center justify-content-end pt-3 px-0 pb-2 ">
        <hr style={{ width: "100%" }} />
        <Footer />
      </div>
    </>
  );
};

export default ManageSubscription;
